export default {
  // 分页查询云采权限列表
  selectYxcUserPayerByPage: '/ygsjzs/yxcUserPayer/selectYxcUserPayerByPage',
  // 查询云采权限详情
  selectYxcUserPayerByUserId: '/ygsjzs/yxcUserPayer/selectYxcUserPayerByUserId',
  // 批量新增云采权限
  insertYxcUserPayer: '/ygsjzs/yxcUserPayer/insertYxcUserPayer',
  // 修改云采权限
  updateYxcUserPayer: '/ygsjzs/yxcUserPayer/updateYxcUserPayer',
  // 物理删除云采权限
  deleteDataYxcUserPayer: '/ygsjzs/yxcUserPayer/deleteDataYxcUserPayer'
}
